import { create } from "zustand";
import { persist } from "zustand/middleware";

export type SiteTheme = "dark-gold" | "dusk-gold" | "ivory-gold" | "frost-gold" | "rose-gold" | "ocean-gold" | "summer-mint";

interface ThemeStore {
  theme: SiteTheme;
  setTheme: (t: SiteTheme) => void;
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      theme: "dark-gold",
      setTheme: (theme) => set({ theme }),
    }),
    { name: "site-theme" }
  )
);
